import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MobileLeftActions from './Actions/Mobile/leftActions';
import MobileRightActions from './Actions/Mobile/rightActions';
function HeaderMobileWrapper(props) {
  const {
    logo,
    leftActions,
    rightActions,
    isMobile,
    className
  } = props;
  const headerClasses = classNames({
    'sib-header': true,
    mobile: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("header", {
    className: headerClasses
  }, /*#__PURE__*/React.createElement("nav", {
    className: "sib-navbar"
  }, leftActions ? /*#__PURE__*/React.createElement("ul", {
    className: "sib-navbar__left-actions"
  }, /*#__PURE__*/React.createElement(MobileLeftActions, {
    logo: logo,
    leftActions: leftActions
  })) : null, rightActions ? /*#__PURE__*/React.createElement("ul", {
    className: "sib-navbar__right-actions"
  }, /*#__PURE__*/React.createElement(MobileRightActions, {
    logo: logo,
    rightActions: rightActions,
    isMobile: isMobile
  })) : null));
}
HeaderMobileWrapper.defaultProps = {
  logo: null,
  leftActions: null,
  rightActions: null,
  isMobile: false,
  className: ''
};
HeaderMobileWrapper.propTypes = {
  logo: PropTypes.object,
  leftActions: PropTypes.array,
  rightActions: PropTypes.array,
  isMobile: PropTypes.bool,
  className: PropTypes.string
};
export default HeaderMobileWrapper;